import React, { useState, useContext } from 'react';
import JobCardWrapper from '../../components/JobCardWrapper/JobCardWrapper';
import JobDetails from '../jobDetails/jobDetails';
import { DataContext } from '../../DataDetails';

import './jobs.css';

export default function Jobs() {
  const { data } = useContext(DataContext);
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [jobDetailsData, setJobDetailsData] = useState(null);

  const handleShowJobDetails = (job) => {
    setShowJobDetails(!showJobDetails);
    setJobDetailsData(job);
  };

  const jobsList = data.jobs_details.map((day) => (
    <JobCardWrapper key={day.date} days={day} handleShowJobDetails={handleShowJobDetails} />
  ));

  return (
    <div className="jobs-page px-3 pt-3 pb-4 mb-5">
      {showJobDetails ? (
        <JobDetails data={jobDetailsData} handleShowJobDetails={handleShowJobDetails} />
      ) : (
        <div>
          <header>
            <h4 className="text-left font-weight-normal text-center">Your Upcoming Jobs</h4>
            <p className="text-right font-weight-bold text-center">{data.page_details.display_months}</p>
          </header>
          {jobsList}
        </div>
      )}
    </div>
  );
}
